import { FC } from 'react';
import { Dialog, Button, ButtonGroup, Flex, Text } from '@/_components';
import type { LargeBulkSendConfirmationDialogProps } from './LargeBulkSendConfirmationDialog.types';

export const LargeBulkSendConfirmationDialog: FC<
  LargeBulkSendConfirmationDialogProps
> = ({
  isOpen,
  onClose,
  onConfirm,
  entityCount,
  bulkSelectedEntityTypes,
  isDraft,
}) => {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={isDraft ? 'Confirm draft' : 'Confirm send'}
      isNarrow
    >
      <Dialog.Content>
        <Flex isColumn={true} gap={4}>
          {!!bulkSelectedEntityTypes?.length ? (
            <Text>
              You are about to {isDraft ? 'draft' : 'send'} questionnaires to{' '}
              <b>{entityCount}</b> entities matching the following entity types:{' '}
              <b>{bulkSelectedEntityTypes.join(', ')}</b>.
            </Text>
          ) : (
            <Text>
              You are about to {isDraft ? 'draft' : 'send'} questionnaires to{' '}
              <b>{entityCount}</b> entities.
            </Text>
          )}
          <Text type="small" color="secondary">
            Are you sure you want to proceed?
          </Text>
        </Flex>
      </Dialog.Content>
      <Dialog.Footer>
        <Flex isBetween={true}>
          <ButtonGroup>
            <Button value="Cancel" onClick={onClose} intent="secondary" />
          </ButtonGroup>
          <ButtonGroup align="right">
            <Button
              value={isDraft ? 'Save draft' : 'Send'}
              intent="primary"
              onClick={onConfirm}
              tooltip="Save as draft and send later. Your users will NOT be able to view this yet."
              withTooltip
            />
          </ButtonGroup>
        </Flex>
      </Dialog.Footer>
    </Dialog>
  );
};
